import * as React from 'react';
import { observer } from 'mobx-react';
import { ITranslationsCollection, translate } from '@estee/elc-service';
import { classes } from '../../utils/Classes';
import styled from 'styled-components';
import { ContentSpacing } from '@estee/elc-base-theme';
import { Body2 } from '@estee/elc-typography';

export interface ILimitedRemainingMessage {
    skuCountRemaining: number;
    translations?: ITranslationsCollection;
}

const StyledBlock = styled.div`
    margin: ${ContentSpacing.space24} 0;
`;

const buildMessageText = (props: ILimitedRemainingMessage) => {
    const { skuCountRemaining } = props;
    const {
        aFewLeftLabel,
        aFewLeftThresholdRange,
        onlyCountLeftLabel,
        onlyCountLeftThresholdLimit
    } = props.translations as ITranslationsCollection;

    const onlyCountLeftNum = Number(onlyCountLeftThresholdLimit) || 0;
    let message = '';

    if (onlyCountLeftNum && skuCountRemaining <= onlyCountLeftNum) {
        message = onlyCountLeftLabel.replace(/::COUNT::/gi, skuCountRemaining.toString());
    } else if (aFewLeftThresholdRange) {
        // threshold range is in the format MAX,MIN
        const thresholdRange = aFewLeftThresholdRange.split(',');
        const min = Number(thresholdRange[1]) || 0;
        const max = Number(thresholdRange[0]) || 0;

        if (thresholdRange.length === 2 && skuCountRemaining <= max && skuCountRemaining >= min) {
            message = aFewLeftLabel;
        }
    }

    return message;
};

export const LimitedRemainingMessage: React.FunctionComponent<ILimitedRemainingMessage> = translate(
    ['aFewLeftLabel', 'aFewLeftThresholdRange', 'onlyCountLeftLabel', 'onlyCountLeftThresholdLimit']
)(
    observer(function LimitedRemainingMessage(props: ILimitedRemainingMessage) {
        const limitedRemainingBlockClassNames = classes('limited-remaining-block');
        const limitedRemainingMessageClassNames = classes('limited-remaining-message');
        const message = buildMessageText(props);

        if (!message) {
            return null;
        }

        return (
            <StyledBlock className={limitedRemainingBlockClassNames}>
                <Body2 className={limitedRemainingMessageClassNames}>{message}</Body2>
            </StyledBlock>
        );
    })
);
